// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"3f0b007e","178":"d1719e8b","419":"d1719e8b","965":"d1719e8b"}[chunkId] + ".chunk.css";
};